import { useMemo } from 'react';
import type { PropsWithChildren } from 'react';
import type React from 'react';

import { useCanUsePaymentRequestButtonMethods } from '#src/app/shared/components/payments';
import type { PaymentType } from '#src/app/shared/utils/payments';

import { AvailablePaymentMethodsContext } from './context';

export const AvailablePaymentMethodsProvider: React.FC<PropsWithChildren<EmptyProps>> = ({ children }) => {
	const canUsePaymentRequestButtonMethods = useCanUsePaymentRequestButtonMethods();

	const availablePaymentMethods = useMemo(() => {
		const paymentMethods: PaymentType[] = ['creditCard', 'paypal'];
		if (canUsePaymentRequestButtonMethods.applePay) {
			paymentMethods.push('applePay');
		}
		if (canUsePaymentRequestButtonMethods.googlePay) {
			paymentMethods.push('googlePay');
		}
		return paymentMethods;
	}, [canUsePaymentRequestButtonMethods]);

	return (
		<AvailablePaymentMethodsContext.Provider
			value={{
				paymentMethods: availablePaymentMethods,
			}}
		>
			{children}
		</AvailablePaymentMethodsContext.Provider>
	);
};
